/**
 * @fileoverview GET handler for the "/engagement/report_builder_2/:app_group_id/developers" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementReportBuilder2Developers } from "./constants";
import type { EngagementReportBuilder2DevelopersResult } from "./types";

export const getEngagementReportBuilder2Developers = reactQueryFetcherAdapter(
  engagementReportBuilder2Developers,
  (signal: AbortSignal, appGroupId: string): Promise<EngagementReportBuilder2DevelopersResult> => {
    return fetch(`/engagement/report_builder_2/${appGroupId}/developers`, "GET", {}, { signal });
  }
);
